import Image from '@tiptap/extension-image'
import { mergeAttributes } from '@tiptap/core'

export default Image.extend({
   name: 'custom-image',

   addAttributes() {
      return {
         ...Image.config.addAttributes(),
         size: {
            default: 'large',
            rendered: true,
            parseHTML: (element) => {
               let cur = 'large'
               let classNames = element.getAttribute('class')

               if (classNames) {
                  if (classNames.includes('custom-image-small')) {
                     cur = 'small'
                  } else if (classNames.includes('custom-image-medium')) {
                     cur = 'medium'
                  } else {
                     cur = 'large'
                  }
               }
               return cur ? cur : 'large'
            },
         }
      }
   },

   addCommands() {
      return {
         setImage: (options) => ({ tr, commands }) => {
            if (tr.selection?.node?.type?.name == 'custom-image') {
               return commands.updateAttributes('custom-image', options)
            }
            else {
               return commands.insertContent({
                  type: this.name,
                  attrs: options
               })
            }
         },
      }
   },

   renderHTML({ node, HTMLAttributes }) {      

      HTMLAttributes.class = ' custom-image-' + node.attrs.size

      return [
         'img',
         mergeAttributes(this.options.HTMLAttributes, HTMLAttributes)
      ]
   }
})
